import { useChannels } from '../channels';

const Channels = () => {
  useChannels();
  return null;
};

export default Channels;
